/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { StreakStatus } from './StreakStatus';
import {
    StreakStatusFromJSON,
    StreakStatusFromJSONTyped,
    StreakStatusToJSON,
    StreakStatusToJSONTyped,
} from './StreakStatus';

/**
 * 
 * @export
 * @interface PlatformStreakLeaderboardEntry
 */
export interface PlatformStreakLeaderboardEntry {
    /**
     * 
     * @type {number}
     * @memberof PlatformStreakLeaderboardEntry
     */
    rank: number;
    /**
     * 
     * @type {string}
     * @memberof PlatformStreakLeaderboardEntry
     */
    userId: string;
    /**
     * 
     * @type {string}
     * @memberof PlatformStreakLeaderboardEntry
     */
    displayName: string;
    /**
     * 
     * @type {string}
     * @memberof PlatformStreakLeaderboardEntry
     */
    avatarUrl?: string;
    /**
     * 
     * @type {number}
     * @memberof PlatformStreakLeaderboardEntry
     */
    currentStreak: number;
    /**
     * 
     * @type {number}
     * @memberof PlatformStreakLeaderboardEntry
     */
    longestStreak: number;
    /**
     * 
     * @type {StreakStatus}
     * @memberof PlatformStreakLeaderboardEntry
     */
    status: StreakStatus;
    /**
     * 
     * @type {boolean}
     * @memberof PlatformStreakLeaderboardEntry
     */
    isCurrentUser?: boolean;
}



/**
 * Check if a given object implements the PlatformStreakLeaderboardEntry interface.
 */
export function instanceOfPlatformStreakLeaderboardEntry(value: object): value is PlatformStreakLeaderboardEntry {
    if (!('rank' in value) || value['rank'] === undefined) return false;
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('displayName' in value) || value['displayName'] === undefined) return false;
    if (!('currentStreak' in value) || value['currentStreak'] === undefined) return false;
    if (!('longestStreak' in value) || value['longestStreak'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function PlatformStreakLeaderboardEntryFromJSON(json: any): PlatformStreakLeaderboardEntry {
    return PlatformStreakLeaderboardEntryFromJSONTyped(json, false);
}

export function PlatformStreakLeaderboardEntryFromJSONTyped(json: any, ignoreDiscriminator: boolean): PlatformStreakLeaderboardEntry {
    if (json == null) {
        return json;
    }
    return {
        
        'rank': json['rank'],
        'userId': json['userId'],
        'displayName': json['displayName'],
        'avatarUrl': json['avatarUrl'] == null ? undefined : json['avatarUrl'],
        'currentStreak': json['currentStreak'],
        'longestStreak': json['longestStreak'],
        'status': StreakStatusFromJSON(json['status']),
        'isCurrentUser': json['isCurrentUser'] == null ? undefined : json['isCurrentUser'],
    };
}

export function PlatformStreakLeaderboardEntryToJSON(json: any): PlatformStreakLeaderboardEntry {
    return PlatformStreakLeaderboardEntryToJSONTyped(json, false);
}

export function PlatformStreakLeaderboardEntryToJSONTyped(value?: PlatformStreakLeaderboardEntry | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'rank': value['rank'],
        'userId': value['userId'],
        'displayName': value['displayName'],
        'avatarUrl': value['avatarUrl'],
        'currentStreak': value['currentStreak'],
        'longestStreak': value['longestStreak'],
        'status': StreakStatusToJSON(value['status']),
        'isCurrentUser': value['isCurrentUser'],
    };
}

